"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _underscore = _interopRequireDefault(require("underscore"));

var _GoodFiltersAndPage = _interopRequireDefault(require("./GoodFiltersAndPage"));

var _CustomModulePurposeOptionsArray = _interopRequireDefault(require("./CustomModulePurposeOptionsArray"));

var _GoodSubTypes = _interopRequireDefault(require("./GoodSubTypes"));

var _TemplatePurposeOptionsArray = _interopRequireDefault(require("./TemplatePurposeOptionsArray"));

var _GoodFiltersAndPage$M;

var SUB_TYPES = _underscore.default.without(_underscore.default.values(_GoodSubTypes.default), _GoodSubTypes.default.ALL, _GoodSubTypes.default.NONE);

var _default = (_GoodFiltersAndPage$M = {}, (0, _defineProperty2.default)(_GoodFiltersAndPage$M, _GoodFiltersAndPage.default.MODULE_PURPOSE, _CustomModulePurposeOptionsArray.default), (0, _defineProperty2.default)(_GoodFiltersAndPage$M, _GoodFiltersAndPage.default.SUB_TYPE, SUB_TYPES), (0, _defineProperty2.default)(_GoodFiltersAndPage$M, _GoodFiltersAndPage.default.TEMPLATE_PURPOSE, _TemplatePurposeOptionsArray.default), _GoodFiltersAndPage$M);

exports.default = _default;
module.exports = exports.default;